export default __webpack_public_path__ + "static/media/cert2.216198ed.png";